/*
  Flowkeeper - Pomodoro timer for power users and teams
  Copyright (c) 2023 Constantine Kulak, Geoffrey Espagne

  This program is free software: you can redistribute it and/or modify
  it under the terms of the GNU General Public License as published by
  the Free Software Foundation; either version 3 of the License, or
  (at your option) any later version.

  This program is distributed in the hope that it will be useful,
  but WITHOUT ANY WARRANTY; without even the implied warranty of
  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
  GNU General Public License for more details.

  You should have received a copy of the GNU General Public License
  along with this program.  If not, see <https://www.gnu.org/licenses/>.
*/

import {Origin} from "./abstract_stragegy";
import {Root} from "./root";

export class Connection {
    public isConnected: boolean;
    public lastSentPingId: string | undefined;
    public lastReceivedPongId: string | undefined;

    public reconnectDelay: number = 5000;
    public pingIntervalDelay: number = 10000;
    public pingAcknowledgeDelay: number = 500;

    public isLoginError: boolean = false;

    public constructor(another?: Connection) {
        if (another) {
            this.isConnected = another.isConnected;
            this.lastSentPingId = another.lastSentPingId;
            this.lastReceivedPongId = another.lastReceivedPongId;
            this.isLoginError = another.isLoginError;
        } else {
            this.isConnected = false;
            this.lastSentPingId = "";
            this.lastReceivedPongId = "";
            this.isLoginError = false;
        }
    }

    public computeIsConnected() {
        this.isConnected = this.lastSentPingId === this.lastReceivedPongId;
    }

    public clone(): Connection {
        return new Connection(this);
    }
}

// Strategies

export function Ping(origin: Origin, data: Root, connection: Connection, seq: number, when: Date, who: string, ...params: string[]): void {
    const id = params[0];
    connection.lastSentPingId = id;
}
Ping.realName = 'Ping'

export function Pong(origin: Origin, data: Root, connection: Connection, seq: number, when: Date, who: string, ...params: string[]): void {
    const id = params[0];
    connection.lastReceivedPongId = id;
}
Pong.realName = 'Pong'